// extracted by mini-css-extract-plugin
export default {"container":"PopoverPaper_container__Bsqpc"};